import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { getAuthProps } from '@topconagriculture/auth';
import { getProfile } from '@topconagriculture/profiling';
import { getLanguages } from '@topconagriculture/language';
import { getCountries } from '@topconagriculture/country';
import { permissionsInstanceSetup } from '@topconagriculture/casbin-react';

import { boostrapApp } from './bootstrap.actions';
import config from '../../../config/config';

export function* bootstrapSaga() {
  yield put(boostrapApp.started({}));
  yield put(getCountries.started({}));
  yield put(getLanguages.started({}));
}

export function* setupPermissionsSaga() {
  const { userId } = yield select(getAuthProps);
  try {
    yield call(permissionsInstanceSetup.setup, userId, config.TENANT_ID);
    yield put(boostrapApp.done({}));
  } catch (error) {
    // tslint:disable-next-line:no-console
    console.log('error: ', error);
    yield put(boostrapApp.failed({ params: { userId }, error }));
  }
}

export function* watchBootstrapSaga() {
  yield all([
    yield takeLatest(getProfile.done, bootstrapSaga),
    yield takeLatest(boostrapApp.started, setupPermissionsSaga),
  ]);
}
